import React, { useEffect, useRef, useState } from 'react'
import moment from 'moment'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import messageActions from 'actions/messages/actions'
import MessageBox from 'forms/client/message/message-box'
import TopInquiry from './inquiry/top-inquiry'
import Proposal from './inquiry/types/proposal'
import Message from './message'
import MessageSystem from './message-system'

const Conversation = ({
  user,
  match,
  getMessages,
  messages,
  sendMessage,
  conversation,
  leadDetail,
  typings,
  handleMessageOrProposal,
  proposalDetail,
  inquiryId,
}) => {
  const isAdmin = leadDetail === null
  const [sender, setSender] = useState({})
  useEffect(() => {
    getMessages(match.params.id)
  }, [match.params.id])
  const msgClient = useRef()
  useEffect(() => {
    msgClient.current.scrollTop = msgClient.current.scrollHeight
  })
  useEffect(() => {
    if (conversation.members && conversation.members.length) {
      setSender(conversation.members.find((mem) => mem.id !== user.id) || {})
    }
  }, [conversation])
  const renderTypings = (users) => {
    let str = ''
    if (users.length) {
      const names = users.map((usr) => decodeURIComponent(usr.user_name))
      str += `${names.join(', ')} is typing ...`
    }
    return <>{str}</>
  }

  const renderMessages = (message, user) => {
    const msgSystem = message.type !== 'message'
    const updateAt = moment(message.updated_at).local().format('MMMM DD YYYY, h:mm A')
    const isOdd = message.sender_id !== user.id
    const members = conversation.members || []
    const avatar = isOdd
      ? members.find((m) => m.id !== user.id)?.profile?.avatar
      : members.find((m) => m.id === user.id)?.profile?.avatar
    return msgSystem ? (
      <MessageSystem key={message.id} message={message.body} isOdd={isOdd} updateAt={updateAt}/>
    ) : (
      <Message
        isOdd={isOdd}
        key={message.id}
        body={message.body}
        avatar={avatar}
        updateAt={updateAt}
        isAdmin={isAdmin}
      />
    )
  }
  return (
    <div className="conversation lg:w-9/12 w-full flex h-full">
      <div
        className={`conversation-messages lg:flex flex-col h-full border-r ${
          leadDetail ? 'lg:w-8/12 w-full' : 'w-full'
        } `}
      >
        {sender && sender.name && (
          <TopInquiry
            name={sender.name}
            address={sender.profile?.address}
            date={leadDetail ? leadDetail.created_date : ''}
            status={conversation.status}
            isAdmin={isAdmin}
            conversationId={conversation.id}
            inquiryId={inquiryId}
            leadDetail={leadDetail}
          />
        )}
        <div className="h-full flex px-5 overflow-y-auto flex-col justify-start" ref={msgClient}>
          {messages &&
            messages.map((message) => {
              return renderMessages(message, user)
            })}
        </div>
        <div className="typing text-xs pl-2 text-gray-600">{renderTypings(typings)}</div>
        <MessageBox
          onSubmit={(values) => {
            return (
              (values.message || (values.attachment && values.attachment.length)) &&
              sendMessage({
                ...values,
                conversationId: match.params.id,
              })
            )
          }}
          form="message-box-form"
          id={conversation.id}
          typingName={user.name}
          handleMessageOrProposal={handleMessageOrProposal}
          proposalDetail={proposalDetail}
          typingId={user.id}
        />
      </div>
      {sender && sender.name && leadDetail && (
        <div className="lg:w-4/12 w-0 relative overflow-y-auto">
          <Proposal handleMessageOrProposal={handleMessageOrProposal} />
        </div>
      )}
    </div>
  )
}

Conversation.propTypes = {
  user: PropTypes.object,
  sendMessage: PropTypes.func,
  conversation: PropTypes.object,
  getMessages: PropTypes.func,
  match: PropTypes.object,
  messages: PropTypes.arrayOf(PropTypes.object),
  leadDetail: PropTypes.object,
  typings: PropTypes.array,
  handleMessageOrProposal: PropTypes.func,
  proposalDetail: PropTypes.object,
  inquiryId: PropTypes.number,
}

const mapStateToProps = ({ messages, auth }, { match }) => ({
  conversation:
    messages.conversation.list.find((con) => Number(con.id) === Number(match.params.id)) || {},
  user: auth.user,
  messages: messages && messages.index.messages,
  leadDetail: messages && messages.index.leadDetail,
  typings: (messages.index.typings || []).filter((typing) => typing.typingId !== auth.user.id),
  proposalDetail: messages.index.proposalDetail,
  inquiryId: messages.index.inquiry_id,
})

const mapDispatchToProps = {
  sendMessage: messageActions.sendMessage,
  getMessages: messageActions.getMessages,
}

export default connect(mapStateToProps, mapDispatchToProps)(Conversation)
